'use strict';

var Uploader$1 = require('./src/Uploader.js');
var UploaderItem = require('./src/UploaderItem.js');

const Uploader = Uploader$1.Uploader;
Uploader.Item = UploaderItem.UploaderItem;

exports.Uploader = Uploader;
//# sourceMappingURL=index.js.map
